var map = {
	"./BoxBanner": [
		89218
	],
	"./BoxBanner.js": [
		89218
	],
	"./BoxHot": [
		31369
	],
	"./BoxHot.js": [
		31369
	],
	"./BoxHotEn": [
		53854
	],
	"./BoxHotEn.js": [
		53854
	],
	"./BoxLink": [
		52608,
		608
	],
	"./BoxLink.js": [
		52608,
		608
	],
	"./BoxMedia": [
		89298
	],
	"./BoxMedia.js": [
		89298
	],
	"./BoxMediaEn": [
		17849
	],
	"./BoxMediaEn.js": [
		17849
	],
	"./BoxNDDN": [
		16748
	],
	"./BoxNDDN.js": [
		16748
	],
	"./BoxNews": [
		37771
	],
	"./BoxNews.js": [
		37771
	],
	"./BoxNotification": [
		44671
	],
	"./BoxNotification.js": [
		44671
	],
	"./BoxPartners": [
		66655
	],
	"./BoxPartners.js": [
		66655
	],
	"./BoxPartnersEn": [
		46088
	],
	"./BoxPartnersEn.js": [
		46088
	],
	"./BoxSuKien": [
		71291
	],
	"./BoxSuKien.js": [
		71291
	],
	"./BoxSuKienEn": [
		65988
	],
	"./BoxSuKienEn.js": [
		65988
	],
	"./BoxTinNoiBatEn": [
		41371
	],
	"./BoxTinNoiBatEn.js": [
		41371
	],
	"./BoxTinTongHop": [
		57912
	],
	"./BoxTinTongHop.js": [
		57912
	],
	"./BoxVBPL": [
		46236
	],
	"./BoxVBPL.js": [
		46236
	],
	"./BoxVBPLEn": [
		56367
	],
	"./BoxVBPLEn.js": [
		56367
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 6607;
module.exports = webpackAsyncContext;